import React from "react";
import Overview from "./Overview";

import { InfoProvider } from "../../context/InfoContext";

export const Contact = () => {
  return (
    <InfoProvider>
      <Overview />
    </InfoProvider>
  );
};
